module.exports = __webpack_public_path__ + "img/solo.app@3x.0532afe0.png";